"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTakerDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const CameraIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CameraIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const jslib_html5_camera_photo_1 = __importStar(require("jslib-html5-camera-photo"));
const react_1 = __importStar(require("react"));
const makeMyClasses = justTaken => ({
    takeButton: {
        width: 60,
        height: 60,
        borderRadius: '50%',
        padding: 7,
    },
    photo: {
        position: 'absolute',
        border: `1px solid ${lib_palette_1.default.Liquorice.main}`,
        boxShadow: `0 0 24px -4px ${lib_palette_1.default.BlackCoral.main}`,
        borderRadius: 8,
        bottom: justTaken ? 48 : 8,
        right: justTaken ? 115 : 8,
        height: justTaken ? 400 : 140,
        transition: !justTaken ? 'height 0.3s' : undefined,
        '&:hover': {
            transition: 'height 0.3s',
            height: 400,
        },
    },
    video: {
        display: 'block',
        margin: 'auto',
        maxWidth: 600,
        height: 400,
        border: `1px solid ${lib_palette_1.default.Liquorice.main}`,
        borderRadius: 8,
        backgroundColor: lib_palette_1.default.Liquorice.main,
        boxShadow: `0 0 24px -4px ${lib_palette_1.default.BlackCoral.main}`,
    },
});
function ImageTakerDialog(props) {
    const { onCancel, onAccept } = props;
    const videoRef = (0, react_1.useRef)();
    const camera = (0, react_1.useRef)();
    const [cameraProblem, setCameraProblem] = (0, react_1.useState)(false);
    const [cameraStarted, setCameraStarted] = (0, react_1.useState)(false);
    const [justTaken, setJustTaken] = (0, react_1.useState)(false);
    const [dataUrl, setDataUrl] = (0, react_1.useState)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [justTaken]);
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            if (videoRef.current && !camera.current) {
                camera.current = new jslib_html5_camera_photo_1.default(videoRef.current);
                camera.current
                    .startCamera(jslib_html5_camera_photo_1.FACING_MODES.ENVIRONMENT)
                    .then(() => {
                    setCameraStarted(true);
                })
                    .catch(() => {
                    setCameraProblem(true);
                });
            }
        }, 500);
    }, []);
    const handleClickTakePhoto = (0, react_1.useCallback)(() => {
        if (!camera.current)
            return;
        const d = camera.current.getDataUri({});
        if (d.length < 10)
            return;
        setDataUrl(d);
        setJustTaken(true);
        setTimeout(() => setJustTaken(false), 500);
    }, []);
    const handleClickAccept = (0, react_1.useCallback)(() => {
        camera.current.stopCamera().then(() => {
            setCameraStarted(false);
        });
        onAccept(dataUrl);
    }, [dataUrl, onAccept]);
    const handleClickCancel = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        try {
            yield camera.current.stopCamera();
        }
        catch (_a) { }
        setCameraStarted(false);
        onCancel();
    }), [onCancel]);
    const cameraReady = cameraStarted && !cameraProblem;
    return (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X800_Y600, closable: false },
        react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Pane_1.default, { grow: true },
                !cameraStarted && !cameraProblem && (react_1.default.createElement(Spinner_1.default, { top: 100, color: lib_palette_1.default.White, busy: true, startDelay: 0 })),
                react_1.default.createElement("video", { className: myCss.video, ref: videoRef, autoPlay: true }),
                !!dataUrl && react_1.default.createElement("img", { className: myCss.photo, alt: "imgCamera", src: dataUrl })),
            react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(Button_1.default, { disabled: !cameraReady, classes: { root: myCss.takeButton }, background: true, icon: react_1.default.createElement(CameraIcon_1.default, { size: 32 }), onClick: handleClickTakePhoto }),
                react_1.default.createElement(Pane_1.default, { grow: true })),
            react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, color: lib_palette_1.default.LavendarGrey, label: lib_i18n_1.default.t('cancel'), onClick: handleClickCancel }),
                react_1.default.createElement(Button_1.default, { disabled: !dataUrl, style: { minWidth: 132 }, color: lib_palette_1.default.positive, label: lib_i18n_1.default.t('done'), onClick: handleClickAccept }),
                react_1.default.createElement(Pane_1.default, { grow: true })))));
}
exports.ImageTakerDialog = ImageTakerDialog;
exports.default = ImageTakerDialog;
